import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CorporateCatering } from "../../components/cateringOrder/CorporateCatering";
import { IndividualCatering } from "../../components/cateringOrder/IndividualCatering";
import CateringOrderSummaryReadonly from "../../components/cateringPackages/CateringOrderSummaryReadonly";
import { selectCateringCheckoutCart } from "../../redux/features/restaurants/restaurantSelectors";
import { selectServiceType } from "../../redux/features/customer/customerSelectors";

export const CateringCheckout = () => {
  const dispatch = useDispatch();
  const checkoutCart = useSelector(selectCateringCheckoutCart);
  const serviceType = useSelector(selectServiceType);
  const [showAddressForm, setShowAddressForm] = useState(false);

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <div className="flex flex-1 flex-row overflow-hidden">
        {/* Left Side: Customer/Company Selection and Address Management */}
        <div className="w-2/3 p-6 flex flex-col flex-1 overflow-y-auto">
          {serviceType === "individual catering" ? (
            <IndividualCatering 
              isCheckout={true} 
              setShowAddressForm={setShowAddressForm}
            />
          ) : (
            <CorporateCatering 
              isCheckout={true} 
              setShowAddressForm={setShowAddressForm}
              isReadonly={true}
            />
          )}
        </div>

        {/* Right Side: Order Summary */}
        <div className="w-1/4 border-l border-gray-200 bg-[#FBFBFB] flex-shrink-0 flex flex-col">
          {Array.isArray(checkoutCart) && checkoutCart.length > 0 && (
            <CateringOrderSummaryReadonly 
              selectedPackages={checkoutCart} 
              showPaymentOptions={true}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default CateringCheckout;
